export const UserRoles = {
  SUPER_ADMIN: "SuperAdmin",
  ADMIN: "Admin",
  DISPATCHER: "Dispatcher",
  TRUCK_DRIVER: "TruckDriver",
  FLEET: "Fleet",
  SAFETY: "Safety",
  RECRUITING: "Recruiting",
  ACCOUNTING: "Accounting",
  IFTA_ADMIN: "IftaAdmin",
} as const;

export type UserRole = (typeof UserRoles)[keyof typeof UserRoles];
